import { render } from "./investorDashboard.vue?vue&type=template&id=a2622cd4&scoped=true"
import script from "./investorDashboard.vue?vue&type=script&lang=js"
export * from "./investorDashboard.vue?vue&type=script&lang=js"

import "./investorDashboard.vue?vue&type=style&index=0&id=a2622cd4&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2622cd4"]])

export default __exports__